import React from 'react';
import { useDropzone } from 'react-dropzone';
import { useDrop } from './hooks';
import { ImageButton } from './ImageButton';

export const ImageUpload = ({
  insertImages,
}: {
  insertImages: () => any;
}): JSX.Element => {
  const [onDrop, uploading] = useDrop(insertImages);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div style={{ marginRight: 'auto' }} {...getRootProps()}>
      <input {...getInputProps()} />
      <ImageButton isDragActive={isDragActive} uploading={uploading} />
    </div>
  );
};
